export default "__VITE_ASSET__BRwVgcOA__"